import React, { useState, useEffect } from "react";
import Header from "../Header/Header";

const BackToTop: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled down
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);

        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    // Scroll to top smoothly
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <div 
            className={`btn-back-to-top ${isVisible ? 'show' : ''}`}
            id="myBtn"
            onClick={scrollToTop}
            style={{ 
                cursor: 'pointer',
                display: isVisible ? 'block' : 'none'
            }}
        >
            <span className="symbol-btn-back-to-top">
                <i className="zmdi zmdi-chevron-up"></i>
            </span>
        </div>
    );
};

export default BackToTop;